module.exports = __webpack_public_path__ + "static/media/lock-solid.3cd9658a.svg";